export enum KYCBiometryAnalysisStatus {
	APPROVED = "APPROVED",
	PROCESSING = "PROCESSING",
	PENDING = "PENDING",
	DISAPPROVED = "DISAPPROVED",
	REPROVED = "REPROVED",
}

export enum DocumentosCopyBiometryAnalysisStatus {
	APPROVED = "APPROVED",
	PROCESSING = "PROCESSING",
	NOT_STARTED = "NOT_STARTED",
	DISAPPROVED = "DISAPPROVED",
	RESEND_NEEDED = "RESEND_NEEDED",
}

export enum StatusFraudAnalysis {
	APPROVED = "APPROVED",
	PENDING = "PENDING",
	DISAPPROVED = "DISAPPROVED",
	REQUEST_ERROR = "REQUEST_ERROR",
	RESEND_NEEDED = "RESEND_NEEDED",
}

export enum ReasonsCode {
	DOCUMENT_ERROR = "DOCUMENT_ERROR",
	UNDERAGE_DOCUMENT_ERROR = "UNDERAGE_DOCUMENT_ERROR",
}
